import { request } from '@utils';
import { ENTITY_TYPES_COMMENTS } from '@constants';

const getGenericTickets = async ({ params }) => {
  const urlParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value)) {
        value.forEach((val) => {
          urlParams.append(key, val);
        });
      } else {
        urlParams.append(key, value);
      }
    }
  });

  const results = await request.get(
    `/v1/generic-tickets?${urlParams.toString()}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateGenericTicket = async ({ genericTicketId, payload }) => {
  const body = {
    body: payload,
  };
  const results = await request.patch(
    `/v1/generic-tickets/${genericTicketId}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getGenericTicketComments = async (genericTicketId) => {
  const results = await request.get(
    `/v1/comments?entityID=${genericTicketId}&entityType=${ENTITY_TYPES_COMMENTS.genericTickets}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addGenericTicketComment = async (payload) => {
  const params = {
    body: payload,
  };
  const results = await request.post(`/v1/comments`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const editGenericTicketComment = async (commentId, comment) => {
  const params = {
    body: { comment },
  };
  const results = await request.patch(`/v1/comments/${commentId}`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteGenericTicketComment = async (commentId) => {
  const results = await request.remove(`/v1/comments/${commentId}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getGenericTicketChangelog = async (genericTicketId) => {
  const results = await request.get(
    `/v1/changelogs?entityID=${genericTicketId}&orderBy=createdAt&order=desc`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

export {
  getGenericTickets,
  updateGenericTicket,
  getGenericTicketComments,
  addGenericTicketComment,
  editGenericTicketComment,
  deleteGenericTicketComment,
  getGenericTicketChangelog,
};
